import React from "react";
import { Add as AddIcon } from "@mui/icons-material";

import { Button } from "@mui/material";
import { MRT_GlobalFilterTextField as GlobalFilterTextField } from "material-react-table";
import { useDispatch } from "react-redux";
import { openTemplateModal } from "app/store/quickTextTemplates/slice/quickTextTemplateSlice";

const QuickTextTemplateTableToolbar = ({ table }) => {
  const dispatch = useDispatch();

  return (
    <>
      <div className="table-toolbar">
        <div className="d-flex justify-between ">
          <div className="d-flex align-items-center" style={{ gap: 15 }}>
            <GlobalFilterTextField table={table} />
            <Button
              variant="contained"
              color="secondary"
              startIcon={<AddIcon />}
              onClick={() =>
                dispatch(
                  openTemplateModal({
                    showModal: true,
                    modalTitle: "Add New Quick Text",
                    selectedTemplate: null,
                  })
                )
              }
            >
              Add Quick Text
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default QuickTextTemplateTableToolbar;
